import React from 'react';
import InformatiiProiect from './InformatiiProiect';
import { Stepper, Step, StepLabel, StepContent, Button, StepIcon, Grid } from '@material-ui/core';
import Drepturi from './Drepturi'
import AppBar from '../../commons/AppBar'
import SpecificComponent from '../../commons/SpecificComponent';
import Commons from '../../commons/Commons';
import EtapeProiect from './EtapeProiect';
import BugeteProiecte from './BugeteProiecte';
import FromServer from './FromServer';
import AddEtapeProiectCards from './AddEtapeProiectCards';
import Utils from '../../providers/Utils';

import { ReactComponent as Step1 } from '../../Pics/iconsManagement/step1.svg';
import { ReactComponent as Step2 } from '../../Pics/iconsManagement/step2.svg';
import { ReactComponent as Step3 } from '../../Pics/iconsManagement/step3.svg';
import { ReactComponent as Step4 } from '../../Pics/iconsManagement/step4.svg';



export default class NewProject extends SpecificComponent {
    constructor(props) {
        super(props);
        this.updateProiect = React.createRef();
        this.state = {
            activeStep: 0,
            steps: [
                { id: 0, done: false, icon: <Step1 /> },
                { id: 1, done: false, icon: <Step2 />  },
                { id: 2, done: false, icon: <Step3 /> },
                { id: 3, done: false, icon: <Step4 />  }
            ],
            proiect:{}

        }


    }




    // getIcons = () => {



    //     return this.state.steps.map((s, idx) => {

    //         return (

                    

    //             <i key={idx} style={{ color: this.state.activeStep === s.id ? 'black' : (s.done ? 'green' : 'gray') }} className='material-icons new-project-icons'>{s.icon}</i>
    //         )
    //     })
    // }







    getStepsContent = (step) => {
        switch (step) {
            case 0:
                return;
            case 1:
                return <Drepturi idproiect={this.props.match.params.idproiect} />;
            case 2:
                return <div style={{ minHeight: 600, overflow: 'scroll' }}> <EtapeProiect idproiect={this.props.match.params.idproiect} history={this.props.history} viewHead={true} /></div>;
            case 3:
                return <BugeteProiecte idproiect={this.props.match.params.idproiect} />
        }
    }

    handleNext = () => {

        if (this.state.activeStep === 0) {
            //    console.log('activeStep :', this.state.activeStep);
            this.updateProiect.current.saveInformatii()
            this.setState({ activeStep: this.state.activeStep + 1 })
        } else {

            this.setState({ activeStep: this.state.activeStep + 1 })
        }
    };

    handleBack = () => {
        this.setState({ activeStep: this.state.activeStep - 1 })
    };

    componentDidMount() {

        this.getInfoProiect()

    }


    goToProject = () => {
        console.log('goToProiect :>> ', );
        this.props.history.push(`/projectdetails/${this.props.match.params.idproiect}/1`)
    }


    goToUtilizatori = () => {
        this.setState({ activeStep: 1 })
    }

    goToInfoProiect = () => {
        this.setState({ activeStep: 0 })
    }

    goToInfoEtape = () => {
        this.setState({ activeStep: 2 })
    }

    goToInfoBuget = () => {
        this.setState({ activeStep: 3 })
    }


    getInfoProiect = async () => {

        let fS = new FromServer();

        let u = new Utils();

        let getInfoProiect = await fS.getInfoProiect(this.props.match.params.idproiect);

        console.log('getInfoProiect :', getInfoProiect);



        let cloneProiect = getInfoProiect[0]

        cloneProiect.perioada_dela = u.ParseDataFromSql(cloneProiect.perioada_dela)

        cloneProiect.perioada_panala = u.ParseDataFromSql(cloneProiect.perioada_panala)

        console.log('cloneProiect :>> ', cloneProiect);

        this.setState({
            proiect: cloneProiect,
     
        })


    }

    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.proiecte.creeazaProiectNou} />

                <Grid style={{ maxWidth: 1000, margin: 'auto' }} container>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.state.proiect.titlu ? (this.state.proiect.titlu.length > 0 ? this.state.proiect.titlu : this.dictionary.proiecte.creeazaProiectNou) : this.dictionary.proiecte.creeazaProiectNou} </h1>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>



                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {this.state.activeStep === 0 &&
                                <InformatiiProiect history={this.props.history}
                                    idproiect={this.props.match.params.idproiect}
                                    goToUtilizatori={this.goToUtilizatori}
                                    goToInfoProiect={this.goToInfoProiect}
                                    goToInfoEtape={this.goToInfoEtape}
                                    goToInfoBuget={this.goToInfoBuget}
                                    showSave={true} ref={this.updateProiect} />
                            }
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {this.state.activeStep === 1 &&
                                <Drepturi idproiect={this.props.match.params.idproiect}
                                    goToUtilizatori={this.goToUtilizatori}
                                    goToInfoProiect={this.goToInfoProiect}
                                    goToInfoEtape={this.goToInfoEtape}
                                    goToInfoBuget={this.goToInfoBuget}
                                />
                            }
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {this.state.activeStep === 2 &&
                                <AddEtapeProiectCards history={this.props.history}
                                    idproiect={this.props.match.params.idproiect}
                                    goToUtilizatori={this.goToUtilizatori}
                                    goToInfoProiect={this.goToInfoProiect}
                                    goToInfoEtape={this.goToInfoEtape}
                                    goToInfoBuget={this.goToInfoBuget}
                                    showSave={true} ref={this.updateProiect} />
                            }
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {this.state.activeStep === 3 &&
                                <BugeteProiecte
                                    goToUtilizatori={this.goToUtilizatori}
                                    goToInfoProiect={this.goToInfoProiect}
                                    goToInfoEtape={this.goToInfoEtape}
                                    goToInfoBuget={this.goToInfoBuget}
                                    goToProiect={this.goToProject}
                                    idproiect={this.props.match.params.idproiect} />
                            }
                        </Grid>

                    </Grid>



                </Grid>




            </div>
        );
    }
}